import { MoovStepCustomerParametersDTO } from "../DTO/moovStepCustomerParametersDTO";
import { BasicRequest } from "./basicRequest";

export class UpdateMoovStepCustomerParametersRequest extends BasicRequest{
    
    public moovStepCustomerParameters!:MoovStepCustomerParametersDTO;

    constructor(){
        super();
    }
}